import '../style/style.scss';
import './nav-swiper';

const allContent = document.querySelectorAll('.capital__markets-content');
const allTabLinks = document.querySelectorAll('.main__block-nav__tabs-wrapper__tab');

const setTab = () => {
    const hash = window.location.hash;

    if (hash) {
        document.querySelector(hash).classList.add('active');
        document.querySelector(hash + 'm').classList.add('active');
        document.querySelector(`#content${hash.slice(5)}`).classList.add('active-tabs');
    } else {
        document.querySelector(`#${allTabLinks[0].id}`).classList.add('active');
        document.querySelector(`#${allTabLinks[0].id}m`).classList.add('active');
        document.querySelector(`#${allContent[0].id}`).classList.add('active-tabs');
    }
}
document.addEventListener('DOMContentLoaded', setTab)

allTabLinks.forEach((item) => {
    item.addEventListener('click', (e) => {
        let hash = e.target.id

        if (window.matchMedia("(max-width: 1023px)").matches) {
            hash = hash.slice(0, -1)
        }

        history.pushState(null, null, '#' + hash);

        allContent.forEach((item) => {
            item.classList.remove('active-tabs');
        });

        allTabLinks.forEach((item) => {
            item.classList.remove('active');
        });

        document.querySelector('#' + hash).classList.add('active');
        document.querySelector('#' + hash + 'm').classList.add('active');
        document.querySelector('#content' + hash.slice(4)).classList.add('active-tabs');
    })
})
